import { Image } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import IngredientInputs from "../../../component/inventory/ingredient/IngredientInputs";
import useUserStore from "../../../stores/store";
import ApiService from "../../../utils/ApiService";
import { validateIngredients } from "../../../services/inventory/ingredient.service";
import CustomLoader from "../../../component/menu/CustomLoader";

export default function IngredientAdd() {
  const { user, restaurantId, showNotification, setNetworkCall } = useUserStore();
  const navigate = useNavigate();
  const [ingredients, setIngredients] = useState([
    {
      id: crypto.randomUUID(),
      name: "",
      unit: "kg",
      minStock: "",
    },
  ]);

  function onHandleAddIngredientInput() {
    setIngredients((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        name: "",
        unit: "kg",
        minStock: "",
      },
    ]);
  }

  function onHandleRemoveIngredientInput(ingId) {
    setIngredients((prev) => prev.filter((item) => item.id !== ingId));
  }

  function onHandleCancel() {
    navigate("/inventory/ingredients");
  }

  function onHandleSave() {
    const ingredientsWithoutId = ingredients
      .filter((el) => {
      // Check if at least one field has a value
      const hasAnyValue =
        el.name.trim() !== "" ||
        el.minStock !== "";

      // Check if all fields are empty
      const allEmpty =
        el.name.trim() === "" &&
        el.minStock === "";

      return hasAnyValue && !allEmpty;
      })
      .map(({ id, ...rest }) => rest);

    if (validateIngredients(ingredientsWithoutId)) {
      ingredientUpsert(ingredientsWithoutId);
      return;
    }
  }

  async function ingredientUpsert(ingredients) {
    if (ingredients.length < 1) return;
    setNetworkCall(true);
    const payload = {
      restaurantId: restaurantId,
      ingredients: ingredients,
    };

    try {
      const res = await ApiService.INVENTORY_INGREDIENT_UPSERT(payload, user.token.token);
      if (res.code !== 200) {
        setNetworkCall(false);
        showNotification(res.data.message);
        return;
      }
      setNetworkCall(false);
      showNotification("Ingredients added successfully!", false);
      return navigate("/inventory/ingredients");
    } catch (err) {
      showNotification(err.response.data.message);
      setNetworkCall(false);
      return;
    }
  }

  function updateIngredientField(fieldName, fieldValue, ingredientId) {
    setIngredients((prev) =>
      prev.map((item) => (item.id === ingredientId ? { ...item, [fieldName]: fieldValue } : item))
    );
  }

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_1"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent title={"Add Ingredient"} listRoute="/inventory/ingredients" />
          </div>

          <div className="w-full h-auto min-h-[50vh] bg-white rounded-[12px] pl-[37px] pt-[50px]">
            {/* item header */}
            <div className="flex items-center space-x-3 font-p_medium text-xs leading-[13px] text-black mb-[10px]">
              <p className="w-[300px]">
                Item name <span className="text-red-500">*</span>
              </p>
              <p className="w-[130px]">
                Item Unit <span className="text-red-500">*</span>
              </p>
              <p className="w-[300px]">
                Minimum Stocks <span className="text-red-500">*</span>
              </p>
            </div>
            {ingredients.map((ing, idx) => (
              <div className="w-full flex items-center gap-x-[30px] mb-2" key={ing.id}>
                {Boolean(ingredients) && ingredients.length > 0 && (
                  <IngredientInputs
                    records={{ ingId: ing.id, ingredients }}
                    updateIngredientField={updateIngredientField}
                  />
                )}

                {ingredients.length > 1 && 
                <button className="mt-1" onClick={() => onHandleRemoveIngredientInput(ing.id)}>
                    <Image src="/images/icons/remove_one.svg" preview={false} />
                  </button>
                }
                {idx === ingredients.length - 1 && (
                  <button className="mt-1" onClick={onHandleAddIngredientInput}>
                    <Image src="/images/icons/add_one.svg" preview={false} />
                  </button>
                )}
                  
              </div>
            ))}

            <div className="flex items-center space-x-3 pt-[76px]">
              <button
                onClick={onHandleCancel}
                className="font-bold w-[100px] h-[42px] bg-[#FCBD10] text-black rounded-[5px] text-base leading-[16px]"
              >
                Cancel
              </button>
              <button
                onClick={onHandleSave}
                className="font-bold w-[100px] h-[42px] bg-black text-white rounded-[5px] text-base leading-[16px] flex items-center justify-center"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
